module.exports = __webpack_public_path__ + "static/media/call_alert.ce61a3d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/call_alert.mp3
// module id = 45l4
// module chunks = 11